module.exports = __webpack_public_path__ + "images/9e51d1ef4098e0aaeadfd21043ab4d29-20_badge.png";